import { useAtomValue } from "jotai";

import { videoPlayerAtom } from "@/constants/atoms";

import { StreamingIcons } from "../Icon";
import { IconButton } from "../IconButton";
import { AirPlayButtonProps } from "./types";

/**
 * AirPlay button for video player controls
 * Works on Safari/WebKit browsers with AirPlay support
 * Uses videoPlayerAtom to access video element directly
 *
 * @param props - The button properties
 * @returns the AirPlay button component
 */
const AirPlayButton = ({ ariaLabel, className }: AirPlayButtonProps) => {
  const videoPlayerState = useAtomValue(videoPlayerAtom);

  const handleClick = () => {
    const videoElement = videoPlayerState.videoRef?.current as any;
    if (videoElement && videoElement.webkitShowPlaybackTargetPicker) {
      videoElement.webkitShowPlaybackTargetPicker();
    }
  };

  return (
    <IconButton
      icon={StreamingIcons.Airplay}
      onClick={handleClick}
      ariaLabel={ariaLabel || "AirPlay"}
      className={className}
    />
  );
};

export { AirPlayButton };
